import React from 'react';
import { useOfferTimer } from '../hooks/useOfferTimer';
export function AnnouncementBar() {
  const {
    isInitialized,
    hours,
    minutes,
    seconds
  } = useOfferTimer();
  if (!isInitialized) return null;
  return <section className="w-full sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1" style={{
    background: '#1a0000',
    borderBottom: '1px solid rgba(204, 0, 0, 0.4)',
    padding: '10px 20px'
  }} data-id="element-1">
      {/* 1. Red pill badge — 50% OFF */}
      <span className="whitespace-nowrap font-['Inter',sans-serif]" style={{
      background: '#cc0000',
      color: '#ffffff',
      fontSize: '11px',
      fontWeight: 700,
      padding: '3px 10px',
      borderRadius: '50px'
    }} data-id="element-2">
        🔥 50% OFF
      </span>

      {/* 2. Headline — ¡OFERTA RELÁMPAGO! */}
      <span className="whitespace-nowrap font-['Inter',sans-serif]" style={{
      color: '#ffffff',
      fontSize: '13px',
      fontWeight: 800,
      letterSpacing: '0.04em'
    }} data-id="element-3">
        ¡OFERTA RELÁMPAGO!
      </span>

      {/* 3. Countdown */}
      <span className="whitespace-nowrap" data-id="element-4">
        <span id="vzla-hours" className="text-[#cc0000] text-[18px] max-sm:text-[16px]" style={{
        fontFamily: "'Courier New', monospace",
        fontWeight: 700
      }} data-id="element-5">
          {hours}
        </span>
        <span style={{
        color: 'rgba(255,255,255,0.4)',
        fontFamily: "'Courier New', monospace",
        fontWeight: 700,
        fontSize: '18px'
      }} data-id="element-6">
          :
        </span>
        <span id="vzla-minutes" className="text-[#cc0000] text-[18px] max-sm:text-[16px]" style={{
        fontFamily: "'Courier New', monospace",
        fontWeight: 700
      }} data-id="element-7">
          {minutes}
        </span>
        <span style={{
        color: 'rgba(255,255,255,0.4)',
        fontFamily: "'Courier New', monospace",
        fontWeight: 700,
        fontSize: '18px'
      }} data-id="element-8">
          :
        </span>
        <span id="vzla-seconds" className="text-[#cc0000] text-[18px] max-sm:text-[16px]" style={{
        fontFamily: "'Courier New', monospace",
        fontWeight: 700
      }} data-id="element-9">
          {seconds}
        </span>
      </span>

      {/* 4. Vertical divider */}
      <div className="hidden sm:block" style={{
      width: '1px',
      height: '16px',
      background: 'rgba(255,255,255,0.15)'
    }} data-id="element-10" />

      {/* 5. Price anchor */}
      <span className="whitespace-nowrap flex items-center gap-2" data-id="element-11">
        <span className="font-['Inter',sans-serif]" style={{
        color: '#666666',
        fontSize: '15px',
        fontWeight: 400,
        textDecoration: 'line-through'
      }} data-id="element-12">
          $27.99
        </span>
        <span style={{
        color: '#cc0000',
        fontSize: '14px',
        fontWeight: 700
      }} data-id="element-13">
          →
        </span>
        <span className="font-['Inter',sans-serif] text-[20px] max-sm:text-[17px]" style={{
        color: '#ffffff',
        fontWeight: 800
      }} data-id="element-14">
          13.99 USD
        </span>
      </span>

      {/* 6. Tagline — hidden on mobile */}
      <span className="hidden md:inline whitespace-nowrap font-['Inter',sans-serif]" style={{
      color: '#888888',
      fontSize: '12px',
      fontStyle: 'italic'
    }} data-id="element-15">
        (Solo por tiempo limitado)
      </span>
    </section>;
}